import {StyleSheet, Dimensions} from 'react-native';
import {styles} from 'src/theme';
import {customResponsiveWidth} from '../../../../../utils/CustomResponsive';
import {windowWidth} from '../../../../../constants';
const {width, height} = Dimensions.get('window');
export default StyleSheet.create({
  slide: {
    alignItems: 'center',
    height: '100%',
    backgroundColor: 'blue',
    width: '100%',
  },
  title: {
    color: '#303261',
    fontSize: 18,
    marginBottom: 14,
    fontFamily: styles.font.IranYekan[400],
  },
  text: {
    color: '#303261',
    fontSize: 14,
    marginBottom: 50,
    fontFamily: styles.font.IranYekan[400],
    textAlign: 'center',
  },
  textContainer: {
    width: windowWidth - 30,
    alignItems: 'center',
  },
  buttontext: {
    fontSize: 18,
    fontFamily: styles.font.IranYekan[400],
  },
  btncontainer: {
    width: '100%',
    paddingHorizontal: 24,
    paddingBottom: 24,
    height: 120,
    position: 'absolute',
    bottom: 0,
    justifyContent: 'flex-end',
  },
  imageContainer: {
    padding: 10,
    justifyContent: 'center',
    backgroundColor: '#fff',
    alignItems: 'center',
    width: customResponsiveWidth(52),
    height: customResponsiveWidth(52),
    borderRadius: 18,
  },
  container: {
    flex: 1,
    paddingHorizontal: 4,
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  header: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginBottom: 7,
    flex: 1,
    paddingHorizontal: 6,
  },
  headerTitle: {
    color: '#2D2D2D',
    fontSize: 14,
    fontFamily: styles.font.IranYekan[400],
    textAlign: 'flex-end',
    paddingRight: 12,
    marginLeft: 'auto',
  },
  closeBtn: {
    alignSelf: 'flex-start',
  },
  description: {
    color: '#5A5A5A',
    fontSize: 11,
    fontFamily: styles.font.IranYekan[400],
    textAlign: 'center',
    padding: 16,
    marginTop: 15,
  },
  description2: {
    color: '#5A5A5A',
    fontSize: 11,
    fontFamily: styles.font.IranYekan[400],
    textAlign: 'center',
  },

  linkButton: {
    paddingVertical: 8,
  },
  linkText: {
    color: '#223EB9',
    fontSize: 14,
    fontFamily: styles.font.IranYekan[400],
    textAlign: 'center',
  },
  buttonContainer: {
    margin: 12,
    paddingVertical: 4,
  },
  reserveTextContainer: {
    justifyContent: 'center',
    paddingVertical: 4,
    alignItems: 'center',
  },
  flexrow: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
